"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const query = (0, client_1.gql) `
  query seating {
    organization {
      _id
      seating {
        publicKey
        secretKey
        designerKey
      }
    }
  }
`;
exports.default = query;
//# sourceMappingURL=seating.query.js.map